export const UserActionTypes = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  GOOGLE_SIGN_IN_START: "GOOGLE_SIGN_IN_START",
  GOOGLE_SIGN_IN_SUCCESS: "GOOGLE_SIGN_IN_SUCCESS",
  GOOGLE_SIGN_IN_FAILURE: "GOOGLE_SIGN_IN_FAILURE",
  EMAIL_SIGN_IN_START: "EMAIL_SIGN_IN_START",
  EMAIL_SIGN_IN_SUCCESS: "EMAIL_SIGN_IN_SUCCESS",
  EMAIL_SIGN_IN_FAILURE: "EMAIL_SIGN_IN_FAILURE",
};
